import { render } from "./NewShipAndReceiving.vue?vue&type=template&id=59612274"
import script from "./NewShipAndReceiving.vue?vue&type=script&lang=js"
export * from "./NewShipAndReceiving.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__